import React from "react";
import {FormattedMessage} from "react-intl";

export default (props) => {

  return (
    <h1 className="page-title">
      <FormattedMessage id="privacy.title" defaultMessage="Privacy policy"/>
    </h1>
  );
}
